import React from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { Section } from "@impero-com/ui";
import { Typography } from "antd";

import { TimePeriod } from "api/generated/model";
import { localizeTimePeriod } from "components/filters/timePeriod";

import * as theme from "./tableWidgetLayout.css";
interface TableWidgetLayoutProps {
    headerTitle: string;
    headerSubtitle: TimePeriod;
    children: React.ReactNode;
    footer?: React.ReactNode;
}

/**
 * Common layout for DashboardControlActivities and DashboardControlProgramOverview widgets
 */
export function TableWidgetLayout({
    headerTitle,
    headerSubtitle,
    children,
    footer,
}: TableWidgetLayoutProps) {
    return (
        <Section>
            <div className={theme.wrapper}>
                <Header title={headerTitle} subtitle={headerSubtitle} />
                {children}
                {footer}
            </div>
        </Section>
    );
}

interface HeaderProps {
    title: string;
    subtitle: TimePeriod;
}

function Header({ title, subtitle }: HeaderProps) {
    const { t } = useTranslation();
    return (
        <>
            <Typography.Title level={5} className={theme.header}>
                {title}
            </Typography.Title>
            <p className={theme.subtitle}>
                {localizeTimePeriod(subtitle.type, t)}
            </p>
        </>
    );
}
